import * as axioCaller from "@services/axio-caller";
import { apiWebV1Url } from "@services/urls/base.js";
import { formErorHandler } from "@services/error-handler";
import { saveJsonApiDataToStore } from "@api/helpers/save-resource-to-store";
import * as storeRegistry from "@api/store-registry";

const baseUrl = `${apiWebV1Url()}/members/session`;

export async function fetchSession() {
  const response = await axioCaller.get({ url: baseUrl });

  saveJsonApiDataToStore(storeRegistry, response.data);

  return response;
}

export async function createSession({
  form,
  formErrors,
}: {
  form: { email: string; password: string };
  formErrors: Record<string, unknown>;
}) {
  try {
    const response = await axioCaller.postApiForm({
      url: baseUrl,
      form,
    });
    return response;
  } catch (e) {
    formErorHandler(e, formErrors);
    throw e;
  }
}

export async function destroySession() {
  return axioCaller.destroy({ url: baseUrl });
}
